// src/serviceWorkerRegistration.ts
const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(\.(25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/)
);

type Config = {
    onUpdate?: (registration: ServiceWorkerRegistration) => void;
    onSuccess?: (registration: ServiceWorkerRegistration) => void;
};

export function register(config?: Config) {
    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
        const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
        if (isLocalhost) {
            checkValidServiceWorker(swUrl, config);
        } else {
            registerValidSW(swUrl, config);
        }
    }
}

function registerValidSW(swUrl: string, config?: Config) {
    navigator.serviceWorker.register(swUrl).then((registration) => {
        registration.onupdatefound = () => {
            const installing = registration.installing;
            if (!installing) return;
            installing.onstatechange = () => {
                if (installing.state === 'installed' && navigator.serviceWorker.controller) {
                    config?.onUpdate?.(registration);
                } else if (installing.state === 'installed') {
                    config?.onSuccess?.(registration);
                }
            };
        };
    });
}

function checkValidServiceWorker(swUrl: string, config?: Config) {
    fetch(swUrl, { headers: { 'Service-Worker': 'script' } }).then((res) => {
        if (res.status === 404) {
            navigator.serviceWorker.ready.then((r) => r.unregister());
        } else {
            registerValidSW(swUrl, config);
        }
    });
}

export function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then((r) => r.unregister());
    }
}